import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';

@Component({
  selector: 'app-add-users',
  templateUrl: './add-users.component.html',
  styleUrls: ['./add-users.component.css']
})

export class AddUsersComponent implements OnInit {
  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  constructor(public httpService: HttpService,) { }
  usersList: any;
  selectedRadioButton = "inspector";
  selectedFacilityGroup!: string;
  showAddForm = false;

  ngOnInit(): void {
    this.httpService.startCallGroup(1,"Add Users");
    this.loadConfiguration();
  }
  add() {
    let row = document.createElement('div');
    row.className = 'd-flex mb-3';
    row.innerHTML = `
      <br>
      <span class="me-2">Hours Before:</span>
      <input type="number">`;
    document.querySelector('.add-more')!.appendChild(row);
  }
  saveUser() {
    this.showAddForm = false;
  }
  scrollToAddForom(id: string) {
    this.showAddForm = true;
    setTimeout(() => {
      let el = document.getElementById(id);
      el!.scrollIntoView();
    }, 100);

  }
  onRadioButtonChange(event: any) {
    this.selectedRadioButton = event.target.id;
  }
  onAdmimRadioButtonChange(event: any) {
  }

  loadConfiguration() {
    this.httpService.get("assets/users.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.usersList = dummyData;
      });
  }
}
